// Routes owned by the Affiliate module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const affiliatePaths = {
    // Affiliates
    affiliatesList: '/affiliates',
    affiliateCreate: '/affiliates/new',
    affiliateDetail: '/affiliates/:id',
    affiliateCommissionPolicies: '/affiliates/commission-policies',
    employeeAffiliatesList: '/affiliates/employees',
} as const
